export default "__VITE_ASSET__DVpAoyb4__"